@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Louisiana</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- Radio Group level one -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[0].formControlName)?.value === null ||
              reactiveForm.get(controls[0].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper
            formControlName="{{ controls[0].formControlName }}"
            (getSelectedItem)="getSelectedItem($event, baseRules['selectionId'], controls[0].formControlName)"
          >
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[1].formControlName)?.value === null ||
              reactiveForm.get(controls[1].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
            '_ml-xlarge': baseRules.Show_Indent,
          }"
        >
          <axis-radio-button-wrapper
            formControlName="{{ controls[1].formControlName }}"
            (getSelectedItem)="getSelectedItem($event, baseRules['selectionId'], controls[0].formControlName)"
          >
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                [class]="control.class"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- Economic UMBI Group level two -->
      @if (controls?.length >= 3) {
        <div></div>
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[2].formControlName)?.value === null ||
              reactiveForm.get(controls[2].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
            '_ml-xlarge': baseRules.Show_Indent,
          }"
        >
          <axis-radio-button-wrapper
            formControlName="{{ controls[2].formControlName }}"
            (getSelectedItem)="getSelectedItem($event, baseRules['selectionId'], controls[0].formControlName)"
          >
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                [class]="control.class"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UMBI Dropdowns -->
      <div>
        <div class="_ml-xlarge">
          @for (
            textKey of [
              "UMBI_SplitLimits_LevelTwo_Radio_Text",
              "Economic_Only_UMBI_SplitLimits_LevelTwo_Radio_Text",
              "UMBI_CombinedSingleLimit_LevelTwo_Radio_Text",
              "Economic_Only_UMBI_CombinedSingleLimit_LevelTwo_Radio_Text",
            ];
            track $index
          ) {
            @if (baseRules?.[textKey]?.includes("show")) {
              <p>{{ textValues[textKey] }}</p>
            }
          }
        </div>
        <div class="axis-grid _ml-large">
          @for (control of controls | slice: 3; track $index) {
            @if (baseRules[control.baseRuleKey]?.includes("show")) {
              <div class="axis-col-sm-6 axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                    '_ml-xlarge': baseRules.Show_Indent,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                  >
                    {{ control.label }}
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                    (onSelect)="getSelectedItem($event, baseRules['selectionId'], control.formControlName)"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select an option.</span
                      >
                    }
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>
      <!--Read Only Values-->
      @if ((baseRules?.["forValue_CombinedSingleLimit_MinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid _ml-large">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="forvalue_combinedsinglelimitmin_30k-pdffield-louisiana">{{ controls[8].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["forValue_Split_EpeaMin_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid _ml-large">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[10].label }}</label>
              <div id="forvalue_split_epeamin_15k_30k-pdffield-louisiana">{{ controls[10].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if (baseRules["Policy_liability_limits_Value"]?.includes("show")) {
        <label class="axis-control-label">UM Bodily Injury Limit (Each Accident):</label>
        <p>${{ policyLiabilityLimitsValue | number }}</p>
      }
    </form>
    <p>{{ textValues?.description }}</p>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Louisiana</h2>

  <!-- Reject texts -->
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_LevelOne_Radio_Text }}
      </label>
    </div>
  }

  <!-- Policy Liability Limits (Economic - Only) -->
  @if (baseRules?.["Policy_liability_limits_Value"]?.includes("show")) {
    <div class="axis-form-group">
      <label class="axis-control-label">Economic - Only</label>
      <label class="axis-control-label">UM Bodily Injury Limit (Each Accident):</label>
      <p>${{ policyLiabilityLimitsValue | number }}</p>
    </div>
  }
}
